// import React from 'react'

// const ViewSupplierchargetype = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewSupplierchargetype





import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete,
  useMediaQuery,
  InputAdornment,
  Link,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Supchargedata, sampleData } from "../../components/grid/GridData";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_01, SETTING_API_04, SUPPLIER_API_11 } from "../../api/ApiModel";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
function ViewSupplierchargetype() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,STAFFMAPLOCODE, COMPCODE, } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState(null);
  const [error, setError] = useState({});
   const [filteredRows, setFilteredRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
  useEffect(() => {
    setPageData({
      title: "Supplier Charges",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);



  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.supchargetypecode === id);
      if (selectedItem) {
        navigate(`/suppliercharges`, { state: { selectedItem, actionText } });
      }
    }
    };
  
    const menuItems = [
      {
        text: "Edit",
        icon: <BorderColorOutlinedIcon />,
      onClick: (supchargetypecode) => handleItemClick(supchargetypecode, "Edit"),
      },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi( SUPPLIER_API_11, "get", {
        COMPCODE,
            LOCCODE:STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result);
      console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.supchargetype.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };


  const addToView = () => {
    navigate("/suppliercharges");
  };

    const addToMap = () => {
    navigate("/mapsuppliercharges");
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
     <Breadcrumbs
                 separator="›"
                 aria-label="breadcrumb"
                 sx={styles.breadcrumb}
               >
                 <Link
                   underline="hover"
                   sx={styles.breadcrumb_link}
                   // href=""
                 >
                   Home
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link}
                   underline="hover"
                   // href=""
                 >
                   Settings
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link_page}
                   underline="hover"
                   // href="#"
                   aria-current="page"
                 >
                    View Supplier Charges
                 </Link>
               </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {Supchargedata.name}
              </Typography>
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 2, xl: 2 }}
              sx={styles.appbar_grid_search}
            >
           

                              <Button
                variant="contained"
                startIcon={<BookmarkAddIcon />}
               fullWidth
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToMap}
              >
                Map Charges
              </Button>

              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
        <ViewDataGrid
  columns={Supchargedata.columns}
  rows={filteredRows.map((row) => ({
    ...row,
    id: row.supchargetypecode || Math.random(),
  }))} // Ensure each row has a unique id
  getRowId={(row) => row.id} // Use the id property for unique identification
  isLoading={isLoading}
  menuItems={menuItems}
  tabletitle={Supchargedata.name}
  gridid="supchargetypecode"
  sx={styles.view_data_grid_page}
/>
        </Box>
      </Box>
    </>
  );
}
export default ViewSupplierchargetype;
